/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmEvalsListRuns } from "../../funcs/llmEvalsListRuns.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListEvalRunsRequest$inboundSchema,
};

export const tool$llmEvalsListRuns: ToolDefinition<typeof args> = {
  name: "llm-evals-list-runs",
  description: `List eval runs

Returns eval runs visible to the authenticated team context. suite_version is a per-suite ordinal and must be paired with suite_id; supplying it alone returns 400.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmEvalsListRuns(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
